import {mapValidationData} from "@/utils/utils";

export default {
    setSelectedValidationProject(state, project) {
        state.selectedValidationProject = project
            state.selectedValidationDevice = null
            state.selectedEvent = null
            state.validationData = []
    },
    setSelectedValidationDevice(state, device) {
        state.selectedValidationDevice = device
    },
    setValidationData(state, data) {
        state.validationData = data
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
        console.log('Set query data mutation: ', state.searchQueryData)
    },
    setValidationTableHeaderData(state, newData) {
        state.validationTableHeaderData = newData
        console.log('Table header data: ', state.qaTableHeaderData)
    },
    resetValidationTableHeaderData(state) {
        state.qaTableHeaderData = {
            activeSorted: {
                field: '',
                order: ''
            },
            activeFilterField: '',
            filters: {avgSpeed: null, userClass: [], userType: null, eventAt: null, direction: null}
        }
    },
    replaceConflictEvents(state, newEvents){
        if(state.validationData && state.validationData.length > 0){
            if(newEvents && newEvents.length > 0){
                newEvents.forEach(newEvent => {
                    let index = state.validationData.findIndex(ev => ev._id === newEvent._id)
                    if(index !== -1){
                        state.validationData.splice(index, 1, newEvent)
                    }
                })
            }

        }
    },
    setSelectedEvent(state, newEvent){
        state.selectedEvent = newEvent
    },
    updateSelectedEvent(state){
        console.log('Update selected event', state.selectedEvent)
        if(state.selectedEvent && state.validationData && state.validationData.length > 0){
            console.log('Update selected event 1')
            let index = state.validationData.findIndex(dt => state.selectedEvent.id === dt._id)
            console.log('Update selected event index: ', index)
            if(index !== -1){
                state.selectedEvent = mapValidationData(state.validationData[index])
                console.log('Update selected event event: ', state.selectedEvent)
            }
        }
    },
    replaceChangedEvents(state, changedEvents){
        if(changedEvents && changedEvents.length > 0 && state.validationData && state.validationData.length > 0){
            changedEvents.forEach(ev => {
                const index = state.validationData.findIndex(vd => vd._id === ev._id)
                if(index !== -1){
                    state.validationData[index].eventValid = ev.eventValid
                    state.validationData[index].eventData.petValue = ev.petValue
                }
            })
        }

    }
}
